import { Material, MaterialSortKey } from '../types';
import { getSortIcon } from './sort-icon';

export function getMaterialStatusRank(material: Material): number {
  if (material.deletedAt) return 0;
  if (!material.active) return 1;
  return 2;
}

export { getSortIcon as getMaterialSortIcon };

export function getMaterialAriaSort(
  column: MaterialSortKey,
  currentColumn: MaterialSortKey,
  direction: 'asc' | 'desc'
): 'ascending' | 'descending' | 'none' {
  return currentColumn === column
    ? direction === 'asc' ? 'ascending' : 'descending'
    : 'none';
}
